import { Component, OnInit } from '@angular/core';
import { ThemesData } from 'src/app/shared/components/view/card-with-check/card-with-check-themes';
import { Observable } from 'rxjs';
import { CreateSurvey } from 'src/app/shared/components/page/page.model';
import { CardService } from "src/app/shared/components/view/card/card.service";
import { BaseHttpService } from 'src/app/shared/services/basehttp.service';
import { NotificationService } from 'src/app/shared/services/notifications.service';
import { Constants } from 'src/app/shared/constants';
import { SurveyViewModel } from 'src/app/shared/models/surveyview.model';
import { UserActivityLogModel } from 'src/app/shared/models/userActivityLog.model';

@Component({
  selector: 'app-card-with-check',
  templateUrl: './card-with-check.component.html',
  styleUrls: ['./card-with-check.component.css']
,  standalone: false
})
export class CardWithCheckComponent implements OnInit {
  constant: Constants = new Constants();
  themedata: ThemesData = new ThemesData();
  templates: Templates[];
  templateanswers: TemplateAnswers[];
  surveyDetails: CreateSurvey;
  surveyId: string;
  constructor(private cardservice: CardService, private baseHttpService: BaseHttpService, private notificationService: NotificationService) { }
  
  ngOnInit() {

    this.get("themes").subscribe(result => {debugger
      if (result != null) {
        this.templates = result;
      }
    });

    this.cardservice.tempdatacurrentMessage.subscribe((message: CreateSurvey) => this.surveyDetails = message)
    this.surveyId = this.surveyDetails["surveyId"];
    if (this.surveyDetails.colorScheme != null && this.surveyDetails.colorScheme != "") {
      this.templates.forEach((element, index) => {
        if (element.theme === this.surveyDetails.colorScheme) {
          element.ischecked = true;
        }
        else {
          element.ischecked = false;
        }
      })

    }
  }

  get(url): Observable<any> {
    return this.themedata.getthemes(url);
  };
 

  selectTheme(event, selectedtheme, parindex) {
    let colorschemes = new ColorSchemes();
    colorschemes.surveyId = this.surveyId;
    if (event.target.checked === false) {
      event.target.checked = true;
      this.templates[parindex].ischecked = true;
      return;
    }
    this.templates.forEach((element, index) => {
      if (parindex === index) {
        element.ischecked = true;
        colorschemes.colorScheme = selectedtheme;
        this.surveyDetails.colorScheme = selectedtheme;
        this.savetheme(colorschemes);
      }
      else {
        element.ischecked = false;
      }
    })
  }
  savetheme(payload: ColorSchemes) {
    
    // this.baseHttpService.post(this.constant.savecolorscheme, payload).subscribe((dt) => {
    //   this.notificationService.showSuccess("Theme has been applied successfully.", "Theme apply Successful!");
    // }); 
    
    let userActivityObj = new UserActivityLogModel();
    userActivityObj.action = "Update";  
    userActivityObj.actionItem = "Survey Settings"; 

    this.baseHttpService.post(this.constant.savecolorscheme, { 
      surveyId: payload.surveyId,
      colorScheme : payload.colorScheme,
      userActivityLog : userActivityObj,
      Name : this.surveyDetails.name, //required on api model
      SurveyGroupId : this.surveyDetails.surveyGroupId, //required on api model
      FromSurveySettings :true //required on api model
    }).subscribe((dt) => {
      this.notificationService.showSuccess("Theme has been applied successfully.", "Theme apply Successful!");
    });   

  }
 



}
export class Templates {
  theme: string;
  backgorund: string;
  foreground: string;
  ischecked: boolean;
}
export class TemplateAnswers {
  Id: string;

}
export class ColorSchemes {
  surveyId: string;  
  colorScheme: string;
}
